import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as DownloadAppActions from "../../store/downloadApp/actions";
import { ApplicationState } from "../../store";
import { Registration } from "../../store/downloadApp/types";
import { months } from "../../util/CommonLists";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const ManageAppInstallations = (props: any) => {
    const dispatch = useDispatch();
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const getAuthenticatedDevices = () => dispatch(DownloadAppActions.actionCreators.getAuthenticatedDevices());
    const revokeRegisteredDevice = (appGuid: string) => dispatch(DownloadAppActions.actionCreators.revokeRegisteredDevice(appGuid));
    const isLoadingDevices = useSelector((state: ApplicationState) => (state.downloadAppState ? state.downloadAppState.isLoadingDevices : false));
    const authenticatedDevices = useSelector((state: ApplicationState) => (state.downloadAppState ? state.downloadAppState.authenticatedDevices : []));

    useEffect(() => {
        getAuthenticatedDevices();
    }, []);

    useEffect(() => {
        if (isLoadingDevices === false && authenticatedDevices && authenticatedDevices.length < 1) {
            closeDialog();
        }
    }, [authenticatedDevices]);

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const remove = (appGuid?: string) => {
        if (appGuid != null) {
            revokeRegisteredDevice(appGuid);
        }
    };

    return (
        <React.Fragment>
            {!isLoadingDevices ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className="las la-mobile"></em>
                        </div>
                        <h1>{tLang("manageAccount.myAccount.manageAppInstallationDialog.title")}</h1>
                    </div>

                    <div className="dialog-body">
                        <p>{tLang("manageAccount.myAccount.manageAppInstallationDialog.devicesInfoContent")}</p>
                        <p>{tLang("manageAccount.myAccount.manageAppInstallationDialog.devicesAccessInfo")}</p>
                        {authenticatedDevices && authenticatedDevices.length < 1 && (
                            <div className="msg-generic msg-small margin-top-xs">
                                <RenderIcons iconName="info-circle" /> You have no authenticated device(s).
                            </div>
                        )}
                        {authenticatedDevices &&
                            authenticatedDevices.map((device: Registration, index) => (
                                <div role="listitem" className="data-row" key={"authenticated-devices-" + index}>
                                    <div className="document-container">
                                        <div role="grid" className="data-grid " id="manage-app-grid" aria-hidden="false">
                                            <div role="row" className="data-row row">
                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="label-app-name">
                                                        {tLang("manageAccount.myAccount.manageAppInstallationDialog.appNameLabel")}
                                                    </div>
                                                </div>
                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-value" aria-labelledby="app-name">
                                                        {device.applicationName}
                                                    </div>
                                                </div>
                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <button
                                                        type="button"
                                                        className="btn-default btn-primary-outline la-pull-right"
                                                        onClick={() => remove(device.appGUID)}
                                                    >
                                                        <span className="btn-text">{tLang("manageAccount.myAccount.manageAppInstallationDialog.removeButtonLabel")}</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div role="row" className="data-row row">
                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="label-device-name">
                                                        {tLang("manageAccount.myAccount.manageAppInstallationDialog.deviceNameLabel")}
                                                    </div>
                                                </div>
                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="data-value" aria-labelledby="device-name">
                                                        {device.deviceName}
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="row" className="data-row row">
                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="label-device-type">
                                                        {tLang("manageAccount.myAccount.manageAppInstallationDialog.deviceTypeLabel")}
                                                    </div>
                                                </div>
                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="data-value" aria-labelledby="device-type">
                                                        {device.deviceType}
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="row" className="data-row row">
                                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                                    <div className="data-label" id="label-last-accessed">
                                                        {tLang("manageAccount.myAccount.manageAppInstallationDialog.lastAccessedLabel")}
                                                    </div>
                                                </div>
                                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                                    <div className="data-value" aria-labelledby="device-type">
                                                        {device.lastAccessed &&
                                                            months[Number(device.lastAccessed.split("/")[0]) - 1] +
                                                                " " +
                                                                device.lastAccessed.split("/")[1].split("T")[0] +
                                                                " " +
                                                                device.lastAccessed.split("/")[2].split(" ")[0] +
                                                                ", " +
                                                                device.lastAccessed.split("/")[2].split(" ")[1].split(":")[0] +
                                                                ":" +
                                                                device.lastAccessed.split("/")[2].split(" ")[1].split(":")[1] +
                                                                " " +
                                                                device.lastAccessed.split("/")[2].split(" ")[2]}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="line-divider margin-vertical-l"></div>
                                </div>
                            ))}
                    </div>
                    <div className="dialog-footer">
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null"></div>
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-primary" onClick={() => closeDialog()}>
                                    <span className="btn-text">{tLang("manageAccount.myAccount.manageAppInstallationDialog.closeButtonLabel")}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="loading"></div>
            )}
        </React.Fragment>
    );
};

export default ManageAppInstallations;
